// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2IUzP","additionalInfo":"AgreementModal_additionalInfo__2bFON"};